
import { defineComponent, computed, onUpdated, PropType } from 'vue'

import { Radar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  PointElement,
  RadialLinearScale,
  LineElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  PointElement,
  RadialLinearScale,
  LineElement
)

export default defineComponent({
  name: 'CbtAllResultChart',
  components: { Radar },

  props: {
    latestTestScore: {
      type: Array as PropType<number[]>,
      required: true
    },
    firstTestScore: {
      type: Array as PropType<number[]>,
      required: true
    },
    testDates: {
      type: Array as PropType<string[][]>,
      required: true
    },
    numberOfTests: {
      type: Number,
      required: true
    }
  },

  setup(props) {
    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        tooltip: {
          callbacks: {
            label: (context: any) => {
              return props.testDates[context.datasetIndex][context.dataIndex]
            }
          }
        }
      },
      scales: {
        r: {
          min: 0,
          max: 30
        }
      }
    }
    const chartData = computed(() => {
      const defaultDatasets = [
        {
          label: '初回の成績',
          backgroundColor: 'rgba(179,181,198,0.2)',
          borderColor: 'rgba(179,181,198,1)',
          pointBackgroundColor: 'rgba(179,181,198,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(179,181,198,1)',
          data: props.firstTestScore
        }
      ]
      if (props.numberOfTests > 1) {
        defaultDatasets.push({
          label: '最新の成績',
          backgroundColor: 'rgba(255,99,132,0.2)',
          borderColor: 'rgba(255,99,132,1)',
          pointBackgroundColor: 'rgba(255,99,132,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(255,99,132,1)',
          data: props.latestTestScore
        })
      }
      return {
        labels: ['第一項', '第二項', '第三項', '第四項', '第五項'],
        datasets: defaultDatasets
      }
    })

    onUpdated(() => {
      const ctx = document.getElementById('chart') as HTMLCanvasElement
      new ChartJS(ctx, {
        type: 'radar',
        data: chartData.value,
        options: chartOptions
      })
    })

    return { chartOptions, chartData }
  }
})
